<template>
  <div class="container-scrapemenu">
    <div class="logo">
      <img
          src="../../public/img/sense-logo.png"
          alt="Logo Sense Company"
      />
    </div>
    <nav>
      <ul class="nav-primary">
        <li>
          <router-link to="/companies/page/">Organisaties</router-link>
        </li>
        <li>
          <router-link to="/reviews/page/">Geurbelevingen</router-link>
        </li>
        <li>
          <router-link to="/favorites/page/">Favorieten</router-link>
        </li>
        <li>
          <router-link to="/exact/page/">Exact</router-link>
        </li>
        <li>
          <router-link @click.native="logout" to="/logout">Logout</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "ScrapeMenu",
  methods: {
    logout(){
      this.$emit("update", "logout");
    }
  }
};
</script>
